import Blue from '~/core';

new Blue({
  name: 'ProductInfoBox',
  selector: '.product-info-box',
    setup(productInfoBox) {
        this.$addEvents(productInfoBox, 'click enter', (event) => {
            if (event.target.tagName === 'A' || event.target.tagName === 'BUTTON') {
                // The clicked element is an anchor tag or button, allow the default behavior
                return;
            }
            const siblings = productInfoBox.closest('.g') || productInfoBox.closest('blue-composition') ? productInfoBox.closest('.g').querySelectorAll('.product-info-box') || productInfoBox.closest('blue-composition').querySelectorAll('.product-info-box') : null;
            const input = productInfoBox.querySelector('input') || null;
            if(input) {
                input.checked = true;
            }
            if(!siblings) {
                return;
            }
            for (let i = 0; i < siblings.length; i++) {
                siblings[i].classList.remove('product-info-box--selected');
            }
            productInfoBox.classList.add('product-info-box--selected');
        });
    },
});
